import Text from "@/components/shared/AppText";
import React from "react";
import { Pressable } from "react-native";
import tw from "twrnc";
import { brandColor } from "../globalStyle";

export const TextLink = ({ text, onPress, style, textStyle }) => {
  return (
    <Pressable onPress={onPress} role="link" style={style}>
      <Text
        multiline={false}
        style={[tw`text-[${brandColor}] font-bold`, textStyle]}
      >
        {text}
      </Text>
    </Pressable>
  );
};
